// Angular
import {
    ApplicationConfig,
    importProvidersFrom,
    inject,
    provideAppInitializer,
    provideCheckNoChangesConfig,
    provideZoneChangeDetection,
    isDevMode,
} from "@angular/core";
import { provideClientHydration, withEventReplay } from "@angular/platform-browser";
import {
    NavigationStart,
    provideRouter,
    Router,
    TitleStrategy,
    withInMemoryScrolling,
} from "@angular/router";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { OVERLAY_DEFAULT_CONFIG } from "@angular/cdk/overlay";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { provideServiceWorker } from "@angular/service-worker";
import { registerLocaleData } from "@angular/common";
import { FormsModule } from "@angular/forms";
import en from "@angular/common/locales/en";
import ru from "@angular/common/locales/ru";
import ro from "@angular/common/locales/ro";

// RXJS
import { filter } from "rxjs";

// Ant
import { provideNzIcons } from "ng-zorro-antd/icon";
import { NZ_DATE_CONFIG } from "ng-zorro-antd/i18n";

// Services
import { SeoTitleStrategy } from "#services/seo-title/seo-title.strategy";
import { SeoTitleStore } from "#services/seo-title/seo-title.store";

// Other
import { httpRequestInterceptor } from "#src/app/core/interceptors/http.interceptor";
import { routes } from "./app.routes";
import { icons } from "./icons-provider";
import { TranslatePipe } from "#pipes/translate/translate.pipe";

registerLocaleData(en);
registerLocaleData(ru);
registerLocaleData(ro);

export const appConfig: ApplicationConfig = {
    providers: [
        TranslatePipe,
        provideCheckNoChangesConfig({ exhaustive: false }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideClientHydration(withEventReplay()),
        provideNzIcons(icons),
        importProvidersFrom(FormsModule),
        provideAnimationsAsync(),
        provideHttpClient(withFetch(), withInterceptors([httpRequestInterceptor])),
        provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: "top" })),
        { provide: TitleStrategy, useClass: SeoTitleStrategy },
        provideAppInitializer(() => {
            const router = inject(Router);
            const store = inject(SeoTitleStore);

            let lastPath = "";

            router.events.pipe(filter((e) => e instanceof NavigationStart)).subscribe((e) => {
                const path = (e as NavigationStart).url.split("?")[0];
                if (path !== lastPath) {
                    store.reset();
                }
                lastPath = path;
            });
        }),
        {
            provide: OVERLAY_DEFAULT_CONFIG,
            useValue: { usePopover: false },
        },
        provideServiceWorker("ngsw-worker.js", {
            enabled: !isDevMode(),
            registrationStrategy: "registerWhenStable:30000",
        }),
        {
            provide: NZ_DATE_CONFIG,
            useValue: {
                firstDayOfWeek: 1,
            },
        },
    ],
};
